// extracted by mini-css-extract-plugin
export default {"root":"contracts_page_root__eKUeY"};